import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=ebd45c76&"
import script from "./ServiceInfo.vue?vue&type=script&lang=js&"
export * from "./ServiceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebd45c76')) {
      api.createRecord('ebd45c76', component.options)
    } else {
      api.reload('ebd45c76', component.options)
    }
    module.hot.accept("./ServiceInfo.vue?vue&type=template&id=ebd45c76&", function () {
      api.rerender('ebd45c76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Common/ServiceInfo.vue"
export default component.exports